<script>

// import axios from 'axios'

export default {
  props: {
    desc: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      name: 'datetime search',
      datetime: null,
			dateTimePicker: {
				enableTime: true,
				dateFormat: 'm/d/Y H:i',
			},
    }
  },
  created: function() {
    this.content = this.text
  },
  methods: {    
    updated: function () {
      const epoch =  parseInt(new Date(this.datetime).getTime()/1000).toString()
      this.$emit('updated', this.desc, this.field, epoch)
    }
  }
}
</script>

<template>
  <div>
    <flat-pickr
						v-model="datetime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
            @on-change="updated"
            @on-close="updated"
					></flat-pickr>
  </div>
</template>


<style>
  .mc_table {
    width: 100%;
    border: 1px;
    border-color: black;
    line-height: 20px !important;
  }

  .mc_table tr{
    height: 20px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }
  
  .high {
    color: #DC001E;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;  
  }

  .medium {
    color: #FECA00;
    fill: #FECA00;
    background-color: #FECA00 !important;
    border: 0px !important;  
  }

  .low {
    color: #01AD00;
    fill: #01AD00;
    background-color: #01AD00 !important;
    border: 0px !important;  
  }

 .severity_high1 {
    color: #fff;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;
    padding: 2px;
  }

 .severity_high {
    color: #DC001E;
  }

  .severity_medium {
    color: #FECA00;
  }

  .severity_low {
    color: #01AD00;
  }

  .prevented {
    color: #01AD00;
  }

  .detected {
    color: rgb(26, 5, 214);
  }

  .light {
    color: rgb(200, 200, 200);
  }

  .reference {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .value {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .tleft {
    text-align: left;
    vertical-align: middle;
  }

  .tcenter {
    text-align: center;
    vertical-align: middle;
  }

  .tarow {
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #e9e9e9;
  }
</style>
